import React, { useEffect } from 'react'
import Modal from 'react-modal'
import { useAttachments } from '../../context/AttachmentContext'
import './AttachModal.css'

Modal.setAppElement('#root')

interface AttachmentModalProps {
  isOpen: boolean
  onRequestClose: () => void
  attachmentNumber: string
}

export const AttachmentModal: React.FC<AttachmentModalProps> = ({
  isOpen,
  onRequestClose,
  attachmentNumber
}) => {
  const { attachments, fetchAttachments, isLoading, error } = useAttachments()

  useEffect(() => {
    if (isOpen) {
      fetchAttachments(attachmentNumber).catch((error) => console.error(error))
    }
  }, [isOpen, attachmentNumber, fetchAttachments])

  console.log(attachments)
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className='attachment-modal'
      overlayClassName='attachment-modal-overlay'
    >
      <h2 className='attachment-modal-header'>{attachmentNumber}</h2>
      {isLoading && <p className='attachment-modal-loading'>Loading {attachmentNumber} files...</p>}
      {(error != null) && <p className='attachment-modal-error'>Error: {error}</p>}
      {!isLoading && (error == null) && (
        <ul className='attachment-list'>
          {attachments.map((attachment) => (
            <li key={attachment.key} className='attachment-item'>
              <a href={attachment.url} target='_blank' rel='noopener noreferrer' className='attachment-link'>
                {attachment.key}
              </a>
            </li>
          ))}
          {attachments.length === 0 && <li className='attachment-item'>No files found.</li>}
        </ul>
      )}
      <button onClick={onRequestClose} className='attachment-modal-close'>Close</button>
    </Modal>
  )
}
